import { fabric } from 'fabric'
import { canvasUtils } from './canvasUtils'

const _maximizeFontTextBox = (
    text,
    targetWidth,
    targetHeight,
    fontFamily,
    fontWeight
) => {
    // NOTE: Setting to something arbitrarily large to ensure we can find a proper fontSize.
    let fontSize = 1000
    let textbox = new fabric.Textbox(text, {
        fontSize: fontSize,
        width: targetWidth,
        fontFamily: fontFamily,
        fontWeight: fontWeight,
    })
    while (textbox.getBoundingRect().height > targetHeight) {
        textbox = new fabric.Textbox(text, {
            fontSize: fontSize--,
            width: targetWidth,
            fontFamily: fontFamily,
            fontWeight: fontWeight,
        })
    }
    return textbox
}

const _loadFromJSONPromise = (json, reviver) => {
    // TODO: Get dimensions from json here if possible
    let canvas = new fabric.Canvas(null, {
        preserveObjectStacking: true,
        width: 600,
        height: 600,
    })
    return new Promise((resolve, reject) => {
        //canvas.loadFromJSON(json, resolve, reviver);
        canvas.loadFromJSON(
            json,
            () => {
                resolve(canvas)
            },
            reviver
        )
    })
}

const replaceStringObject = async (obj, varsMap) => {
    if (!(obj.name in varsMap)) {
        console.log('object name in interpolation map name:', obj.name)
        return
    }

    let text = varsMap[obj.name]
    const tb = _maximizeFontTextBox(
        text,
        obj.width,
        obj.height,
        obj.fontFamily,
        obj.fontWeight
    )
    obj.fontWeight = tb.fontWeight
    obj.fontSize = tb.fontSize
    obj.text = text
    return
}

const replaceImageObject = async (obj, varsMap) => {
    if (!(obj.name in varsMap)) {
        console.log(
            '_replaceImage: object name in interpolation map name:',
            obj.name
        )
        return
    }
    obj.objects[0].src = varsMap[obj.name]
    return
}

const renderTemplateImage = async (json) => {
    const canvas = await _loadFromJSONPromise(json)
    const dataUrl = canvas.toDataURL({ format: 'png', multiplier: 2 })
    const file = canvasUtils.dataUrlToFile(dataUrl)
    return {
        canvas: json,
        dataUrl: dataUrl, //TODO: We should remove dataUrl at some point and use presigned uploads everywhere
        file: file,
    }
}

const FUNC_MAP = {
    'prompt-textbox': replaceStringObject,
    'template-textbox': replaceStringObject,
    'template-image': replaceImageObject,
}

export const TemplateInterpolator = {
    interpolate: (canvasJSON, varsMap) => {
        let promises = []
        canvasJSON.objects.forEach((obj) => {
            if (!(obj.type in FUNC_MAP)) {
                // Not valid for interpolation...skipping.
                return
            }

            promises.push(FUNC_MAP[obj.type](obj, varsMap))
        })

        return Promise.all(promises).then(() => renderTemplateImage(canvasJSON))
    },
}
